var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isLogoSizeChange ? 'logo' : 'company-detail-logo'},[_c('img',{staticClass:"img-fit w-100 h-100",attrs:{"src":_vm.logo ? _vm.logo : _vm.noLogo,"alt":"Company Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }